export default {
    ordered: {
        error: {
            dependency_0001: "Nelze objednat, protože {name} je v košíku | Nelze objednat, protože {name} je v košíku",
            dependency_0002: "Nelze objednat, protože bylo objednáno {name} Nelze objednat, protože bylo objednáno {name}",
            cart: "Nelze objednat, protože v košíku jsou položky stejného typu"
        },
        type: {
            "ac_router": "Již jsem si objednal jiný AC router",
            "chair": "Už jsem si objednal/a jinou židli",
            "default": "Už objednáno",
            "default_multiple": "Již jsem si objednal/a podobné produkty",
            "desk": "Už jsem si objednal/a jiný stůl",
            "desktop": "Už jsem si objednal jiný stolní počítač",
            "desktop_riser": "Už jsem si objednal jiný podstavec pro stolní počítač.",
            "detector": "Už jsem si objednal různé vaporizéry a detektory hluku",
            "displayport_cable": "Už jsem si objednal jiný kabel DisplayPort.",
            "docking station": "Už jsem si objednal jinou dokovací stanici",
            "dual_usb_adapter": "Již jsem si objednal jiný dvoupásmový USB adaptér",
            "ear cushion": "Už jsem si objednal/a jiné náušníky",
            "footrest": "Už jsem si objednal jinou opěrku nohou",
            "hdmi_cable": "Už jsem si objednal různé HDMI kabely",
            "hdmi_displayport_cable": "Již jsem si objednal jiný kabel HDMI-DisplayPort.",
            "hdmi_vga_cable": "Už jsem si objednal jiný kabel HDMI-VGA",
            "headset": "Už jsem si objednal jiné audio zařízení",
            "keyboard": "Už jsem si objednal jinou klávesnici",
            "kvm switch": "Už jsem si objednal jiný KVM přepínač",
            "kvm_switch": "Už jsem si objednal jiný KVM přepínač",
            "lamp": "Už jsem si objednal jinou lampu",
            "laptop stand": "Už jsem si objednal jiný stojan na notebook",
            "laptop": "Už jsem si objednal jiný notebook",
            "mesh_router": "Už jsem si objednal jiný síťový router",
            "monitor": "Už jsem si objednal jiný monitor",
            "mouse": "Už jsem si objednal různé myši",
            "patch_cord": "Už jsem si objednal jiný patchcord cat6",
            "power": "Již jsem si objednal jiný napájecí kabel",
            "power_center": "Již jsem si objednal/a jiný Power Center",
            "power_strip": "Už jsem si objednal jiný prodlužovací kabel",
            "printer": "Už jsem si objednal jinou tiskárnu",
            "smart_plug": "Už jsem si objednal/a jinou mini chytrou zástrčku",
            "smart_power_strip": "Už jsem si objednal/a jiný chytrý prodlužovací kabel",
            "speakerphone": "Už jsem si objednal jiný hlasitý odposlech",
            "stylus": "Už jsem si objednal jiný stylus",
            "tablet": "Už jsem si objednal jiný tablet",
            "tablet accessory": "Již jsem si objednal/a jiné příslušenství k tabletu",
            "thunderbolt_cable": "Už jsem si objednal jiný kabel USB-C na Thunderbolt",
            "travel_router": "Už jsem si objednal jiný cestovní router",
            "usb hub": "Už jsem si objednal jiný USB hub",
            "usb_adapter": "Už jsem si objednal jiný USB adaptér",
            "usb_hub": "Už jsem si objednal jiný náboj",
            "webcam": "Už jsem si objednal jinou webkameru"
        },
        product: "Objednané"
    },
    request: "Žádost",
    add: "Přidat do košíku",
    remove: "Odebrat z košíku",
    added: "Přidáno do košíku",
    view: "Zobrazit položku"
}